<template>
	<v-row align-content="center">
		<v-col
			cols="12"
			lg="4"
			align-self="center"
		>
			<media-gallery @selected="onSelect" />
		</v-col>
		<template v-if="imageSrc">
			<v-col
				lg="8"
			>
				<v-icon
					v-if="imageSrc"
					@click="cancelImg"
				>
					close
				</v-icon>
				<v-img
					:src="imageSrc"
					max-width="150"
				/>
			</v-col>
		</template>
	</v-row>
</template>

<script>
import MediaGallery from "./MediaGallery";

export default {
	name: "MediaGalleryPreview",
	components: { MediaGallery },
	props: { value: [String, Number], imageUrl: String },
	data () {
		return {
			src: null,
		};
	},
	computed: {
		image: {
			get () {
				return this.value;
			},
			set (val) {
				this.$emit("input", val);
			},
		},
		imageSrc () {
			return this.src || this.imageUrl;
		},
	},
	methods: {
		onSelect (val) {
			this.image = val.id;
			this.src = val.imageSrc;
			this.$emit("getImg", val);
		},
		cancelImg () {
			this.imageUrl = null;
			this.image = null;
			this.src = null;
		},
	},
};
</script>

<style scoped></style>
